import { useSelector } from "react-redux";
import { selectSelectedElement } from "../../../app/slices/TrainingSlice";
import { IImageDragAndDropQuiz } from "../../../models/interactions/ImageDragAndDropQuiz";
import { useTrainingLocalization } from "../../trainingLocalization/TrainingLocalizationHooks";
import PiInteractionTitlePreview from "../components/PiInteractionTitlePreview";
import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import ImageDragAndDropQuizPreviewBody from "./ImageDragAndDropQuizPreviewBody";

export default function ImageDragAndDropQuizPreview() {
  const quiz = useSelector(selectSelectedElement) as IImageDragAndDropQuiz;
  const { getValue, changeValue } = useTrainingLocalization();

  const title = (
    <PiInteractionTitlePreview
      value={getValue(quiz.title)}
      onChange={(newValue, shortcode) =>
        changeValue(quiz.title, newValue, shortcode)
      }
      placeholder="Quiz Title"
      key={quiz.id}
    />
  );

  return (
    <PiPopupWindowPreview
      size="large"
      title={title}
      body={<ImageDragAndDropQuizPreviewBody />}
    />
  );
}
